module.exports = __webpack_public_path__ + "img/2.80dbc2c7.png";